import { render, staticRenderFns } from "./CommonFooterEn.vue?vue&type=template&id=2237a3c7&"
import script from "./CommonFooterEn.vue?vue&type=script&lang=ts&"
export * from "./CommonFooterEn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports